module.exports = __webpack_public_path__ + "static/media/29COICT3.a1e8e0dc.jpg";